import { CAPABILITY_KEYS } from '../constants/capabilities';

const EMPTY_PERMISSION = {
  view: false,
  edit: false,
  create: false,
  delete: false,
};

export const getCapabilityPermission = (capabilities, capabilityKey) => {
  return capabilities?.[capabilityKey] || EMPTY_PERMISSION;
};

export const isCapabilityVisible = (capabilities, capabilityKey) => {
  if (!capabilities || typeof capabilities !== 'object') {
    return false;
  }

  return Boolean(getCapabilityPermission(capabilities, capabilityKey).view);
};

export const isCapabilityAccessible = (capabilities, capabilityKey) => {
  if (!isCapabilityVisible(capabilities, capabilityKey)) {
    return false;
  }

  const permission = getCapabilityPermission(capabilities, capabilityKey);
  return Boolean(permission.edit || permission.create || permission.delete);
};

export const canAccessOrgSettings = (capabilities, userRole) => {
  if (userRole === 'Owner') {
    return true;
  }

  if (!hasLoadedCapabilities(capabilities)) {
    return userRole === 'Admin' || userRole === 'Owner';
  }

  return (
    isCapabilityVisible(capabilities, CAPABILITY_KEYS.ORGANIZATION_PROFILE) ||
    isCapabilityVisible(capabilities, CAPABILITY_KEYS.ORGANIZATION_USERS)
  );
};

export const hasLoadedCapabilities = (capabilities) => {
  return capabilities && typeof capabilities === 'object' && Object.keys(capabilities).length > 0;
};
